import React from "react";
import { HighlightModal } from "./HighlightModal";
import { INITIAL_STATE, highlighterReducer, EVENTS } from "./Highlight.reducer";
import { Utilities } from "@learningblocks/exp-constants";
const { GLOSSARY_API_DETAILS, getIndividialDataFromAirtable } = Utilities;
import { GlossaryProvider } from "@learningblocks/storybook-components";
import { HighlightProvider } from "@learningblocks/shared-components";

const API_DETAILS = {
  URL: GLOSSARY_API_DETAILS.URL,
  KEY: GLOSSARY_API_DETAILS.KEY,
};

export function HighlightWrapper() {
  const [tooltip, dispatch] = React.useReducer(
    highlighterReducer,
    INITIAL_STATE
  );
  const { state, onCloseTooltip } = React.useContext(HighlightProvider.Context);
  const { onOpenGlossary } = React.useContext(GlossaryProvider.Context);

  React.useEffect(() => {
    if (state.visible && !(state.contentTitle || state.contentDescription)) {
      fetchDetails();
      if (state.mobileFunction === true) {
        onCloseTooltip();
        onOpenGlossary(tooltip.tooltipDetails.title);
      }
    }
  }, [state.visible && state.contentId]);

  const fetchDetails = async () => {
    const contentId = state.contentId;
    try {
      dispatch({ type: EVENTS.FETCH_DETAILS_STARTED });
      const response = await getIndividialDataFromAirtable(
        API_DETAILS.URL,
        API_DETAILS.KEY,
        contentId
      );
      dispatch({ type: EVENTS.FETCH_DETAILS_SUCCESS, payload: response });
    } catch (error) {
      dispatch({ type: EVENTS.FETCH_DETAILS_FAILED });
    }
  };
  return (
    <>
      {state.visible && (
        <HighlightModal
          clickedContent={state.clickedContent}
          close={onCloseTooltip}
          contentId={state.contentId}
          tooltipApi={tooltip.tooltipApi}
          title={state.contentTitle || tooltip.tooltipDetails.title}
          description={
            state.contentDescription || tooltip.tooltipDetails.description
          }
          image={state.contentImage || tooltip.tooltipDetails.image}
          openGlossary={onOpenGlossary}
        />
      )}
    </>
  );
}
